<template>
  <div class="container">
    <div class="separator"></div>
    <div class="control-container">
      <router-link :to="'/customers-page/edit/' + 0">
        <el-button type="warning" size="small">
          新增客户
        </el-button>
      </router-link>
    </div>
    <div class="target-container">
      <el-table
        ref="table"
        height="100%"
        border
        :data="displayData"
        :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
        :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
        header-cell-class-name="headerCellName">
        <el-table-column prop="customerName" label="客户名称"/>
        <el-table-column prop="contact" label="联系人"/>
        <el-table-column prop="contactPhone" label="联系电话"/>
        <el-table-column prop="contactAddr" label="地址"/>
        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <router-link :to="'/customers-page/edit/' + scope.row.id">
              <el-button type="text" class="link">
                修改
              </el-button>
            </router-link>
            <span class="vertical-separator"/>
            <el-button type="text" @click="deleteClick(scope.$index, scope.row.id)" class="link">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      :total="totalCount"
      :pageSize="perpage"
      :current-page.sync="page"
      @current-change="onChangePage"
    />
  </div>
</template>

<script>
  import {
    Pagination,
  } from '@/components';
  import {customersList, customersDelete} from '@/api/customers';

  export default {
    name: 'ProductStorageList',
    components: {
      Pagination,
    },
    data() {
      return {
        page: 1,
        perpage: 20,
        totalCount: 0,
        listData: [],
        deleteChipId: undefined,
      };
    },
    computed: {
      displayData() {
        return this.listData;
      },
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.customersList();
      })
    },
    methods: {
      onChangePage() {
        this.customersList();
      },
      deleteClick(index, id) {
        this.deleteChipId = id;
        this.$confirm('此操作将永久删除该客户, 是否继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.deleteCustomers();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      async deleteCustomers() {
        try {
          await customersDelete({id: this.deleteChipId});
          this.$message({
            type: 'success',
            message: '删除成功'
          });
          this.customersList();
        } catch (e) {
        }
      },
      async customersList() {
        try {
          const res = await customersList({
            page: this.page,
            perpage: this.perpage,
          });
          const {data} = res;
          if (data.count !== undefined) {
            this.totalCount = data.count;
          }
          this.listData = data.records;
        } catch (e) {
          // do nothing.
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .container {
    height: 100%;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
  }

  .el-form {
    padding: 10px 20px 0;
  }

  .el-form-item {
    margin-bottom: 10px;
  }

  .control-container {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    margin: 10px 20px;
  }

  .target-container {
    flex: 1;
    display: -webkit-flex;
    display: flex;
    margin: 0 20px 0;
    height: 100%;
    overflow: auto;
  }

  .vertical-separator {
    display: inline-block;
    width: 1px;
    height: 12px;
    margin: 0 13px;
    vertical-align: middle;
    background: #e8e8e8;
  }

  .link {
    color: #169BD5;
    padding: 0 5px;
  }
</style>
<style>
  .headerCellName {
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
  }

  .small_label .el-form-item__label {
    font-size: 12px;
  }
</style>
